import { useState } from "react";
import { GiRoundStar } from "react-icons/gi";
import { BsBookmarkHeart, BsFillBookmarkHeartFill } from "react-icons/bs";
import { useHistory } from "react-router";
import {
  postAddProductToCartService
} from "../../api/apiServices";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { useSnackbar } from "notistack";
import { Button } from "@mui/material";

const SingleProduct = ({ product, disabled, name }) => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const userId = localStorage.getItem("userId");
  const [qty, setQty] = useState(1);
  const maxQty = product.quantity ?? 0;
  const addProductToCart = async (product_id) => {
    const data = { product_id: parseInt(product_id), qty };

    postAddProductToCartService(data)
      .then((response) => {
        if (response.data.success) {
          enqueueSnackbar("Product Added to Cart", { variant: "success" });
          window.dispatchEvent(new CustomEvent("cartUpdated"));
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <div
      className={`flex flex-col h-full sm:flex-col bg-white/[0.5] rounded-lg shadow-md border-2 border-black/[0.05] overflow-hidden transition-transform ${disabled ? "pointer-events-none" : "cursor-pointer"
        }`}
    >
      <div
        className="flex items-center justify-center bg-black/[0.075] xs:w-1/2 w-full sm:w-full relative flex-shrink-0"
        style={{ width: "100%", paddingBottom: "100%", position: "relative" }}
        onClick={() => {
          history.push(`/products/${product._id}`, name === "Search" ? { from: "search" } : undefined);
        }}
      >
        <img
          src={`https://pancham-bucket.s3.amazonaws.com/${product.image}`}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectFit: "cover" }}
        />
        {(product.quantity ?? 0) > 0 && (product.quantity ?? 0) < 5 && (
          <div className="absolute top-0 left-0 z-9 bg-amber-600 text-white px-2 py-1 m-2 rounded font-medium text-sm">
            Only {(product.quantity ?? 0)} left
          </div>
        )}
        <div className="absolute top-0 right-0 z-9 m-2 flex flex-col items-end gap-1">
        {(product.quantity ?? 0) <= 0 && (
          <span className="bg-red-500 text-white px-2 py-1 rounded font-medium text-sm">Sold Out</span>
        )}
        {product.condition_type === "Preowned" && (
          <span className="bg-amber-600 text-white px-2 py-1 rounded font-medium text-sm">Preowned</span>
        )}
      </div>
      </div>

      <div className="p-3 flex flex-col flex-1 min-h-0 gap-2 mt-2">
        <div className="flex-1 min-h-0 flex flex-col">
          <div className="flex justify-between gap-2">
            <div className="flex flex-col min-w-0">
              <span className="text-xl font-medium">{product.name}</span>
              <span className="flex items-center gap-1">
                <span className="text-xs text-gray-400">{product.label}</span>
              </span>
            </div>

            <div className="flex flex-col items-end flex-shrink-0">
              <span className="text-amber-600">₹{product.newPrice}</span>
              {product.price > product.newPrice && (
                <span className="text-sm text-gray-600 line-through">
                  ₹{product.price}
                </span>
              )}
            </div>
          </div>
          {product.brand !== 'Liquid' && <p className="text-sm text-gray-600">{product.brand}</p>}
          {product.type !== 'Liquid' && <p className="text-sm text-gray-400">{product.type}</p>}
          <p className="text-sm text-gray-600 line-clamp-2 sm:line-clamp-3">{product.description}</p>
        </div>
        <div className="w-full pt-2 border-t mt-auto flex-shrink-0 space-y-2">
          {name !== "Coming Soon" && (
            <>
              <div className="flex items-center justify-between gap-2 flex-wrap">
                {/* <span className="text-xs text-gray-500">Max Quantity: {maxQty}</span> */}
                {/* <div className="flex items-center border border-gray-300 rounded overflow-hidden">
                  <button
                    type="button"
                    onClick={(e) => { e.stopPropagation(); setQty((p) => Math.max(1, p - 1)); }}
                    disabled={qty <= 1 || product.quantity === 0}
                    className="px-2 py-0.5 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 text-sm"
                  >
                    −
                  </button>
                  <span className="px-2 py-0.5 min-w-[1.5rem] text-center text-sm bg-white border-x border-gray-300">
                    {qty}
                  </span>
                  <button
                    type="button"
                    onClick={(e) => { e.stopPropagation(); setQty((p) => Math.min(maxQty || 1, p + 1)); }}
                    disabled={product.quantity === 0 || qty >= maxQty}
                    className="px-2 py-0.5 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 text-sm"
                  >
                    +
                  </button>
                </div> */}
              </div>
              <button
                className={`flex items-center justify-center gap-2 text-sm w-full py-2 rounded ${
                  (product.quantity ?? 0) <= 0
                    ? "bg-gray-400 text-white cursor-not-allowed"
                    : !userId
                    ? "btn-rounded-secondary disabled:cursor-not-allowed"
                    : "btn-rounded-secondary"
                }`}
                disabled={(product.quantity ?? 0) === 0}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!userId) history.push("/login");
                  else if ((product.quantity ?? 0) > 0) addProductToCart(product._id);
                }}
              >
                {(product.quantity ?? 0) <= 0 ? "Sold Out" : !userId ? "Login to Shop" : (
                  <span className="flex items-center gap-0.5">
                    <HiOutlineShoppingCart className="text-lg" />Add to cart
                  </span>
                )}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleProduct;
